document.addEventListener("DOMContentLoaded", function () {
  const element = document.querySelector("[data-component=cp-login]");

  if (!element) return;

  // CP admin "Log in as customer on JapanHaul": the one-time token arrives in the URL fragment (never sent
  // to servers or in Referer). Pass it to the CP login iframe, which then posts the customer's credentials
  // back like a normal login, and drop it from the URL.
  const hashParams = new URLSearchParams(window.location.hash.slice(1));
  const handoff = hashParams.get("cp_admin_handoff");
  const iframe = element.querySelector('iframe[src*="/japan_haul_auth/login"]');

  if (handoff && iframe) {
    const src = new URL(iframe.src);
    src.searchParams.set("admin_handoff", handoff);
    iframe.src = src.toString();

    window.history.replaceState(null, "", window.location.pathname + window.location.search);
  }

  window.addEventListener("message", function (event) {
    // Only trust messages from the CP login iframe.
    if (!iframe || event.source !== iframe.contentWindow) return;
    if (event.origin !== new URL(iframe.src).origin) return;

    if (event.data && event.data.type === "login") {
      localStorage.setItem("ichigo_admin_user", event.data.serialized_user);
      localStorage.setItem("ichigo_admin_token", event.data.token);

      const emailInput = document.querySelector("#CustomerLoginForm #CustomerEmail");
      const passwordInput = document.querySelector("#CustomerLoginForm #CustomerPassword");
      const form = document.querySelector("#CustomerLoginForm form");

      if (emailInput) emailInput.value = event.data.email;
      if (passwordInput) passwordInput.value = event.data.generated_password;
      if (!form) return;

      // Shopify binds hCaptcha to the login form on focusin and adds the token on the submit event;
      // form.submit() skips both and Shopify rejects it with "Missing CAPTCHA token". Wait up to 5s
      // for the binding, then submit anyway in case CAPTCHA is turned off.
      form.dispatchEvent(new Event("focusin", { bubbles: true }));
      let attempts = 50;
      const submitWhenBound = function () {
        if (form.dataset.hcaptchaBound || --attempts <= 0) form.requestSubmit();
        else setTimeout(submitWhenBound, 100);
      };
      submitWhenBound();
    }
  });
});
